export default __webpack_public_path__ + "7436d8c0179b88cdb86c8c2ba1dd9db3.png";